import { Field } from 'scripts/type'

export default function getDefaultShowFields(fields: Field[]) {
  const targetCodes = fields
    .map((field) => {
      return (field.showRules?.map((rule) => rule.targets) || []).flat()
    })
    .flat()
  return fields.filter((field) => !targetCodes.includes(field.code)).map((field) => [field])
}
